var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"widget-single-number"},[_c('span',{staticClass:"widget-single-number__quantity",on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm.value)+" ")]),_c('span',{staticClass:"widget-single-number__text"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }